import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router';

import { routes } from './app.routes';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './infrastructure/Interceptor/auth.interceptor';
import { provideToastr } from 'ngx-toastr';
import { provideNgxMask } from 'ngx-mask';
export const appConfig: ApplicationConfig = {
  providers: [provideZoneChangeDetection({ eventCoalescing: true }),
   provideRouter(routes,withPreloading(PreloadAllModules)),
  importProvidersFrom(BrowserAnimationsModule),provideToastr(),
  provideHttpClient(withInterceptors([authInterceptor])),provideNgxMask()]
};
